export interface GetPaidInitialData {
  name: string;
  id: number;
  key: string;
  status: string;
  data: {
    main_fields: {
      name: string;
      key: string;
      fields: {
        key: string;
        default_value: string | UploadFieldValue;
        values: [
          {
            key: string;
            value: string;
          },
        ];
      };
    }[];
  };
}

export type UploadFieldValue = {
  file?: object;
  name?: string;
  originFileObj?: File;
  status?: string;
  uid?: string;
  url?: string;
}[];

export type GetPaidData = Record<
  string,
  {
    key: string;
    defaultValue?: string | UploadFieldValue;
    values?: { value: string; label: string }[];
  }
>;

export interface GetPaidRawFormData {
  [GET_PAID_STEP.ORGANIZATION_INFO]: {
    organization_industry: string;
    organization_size: string;
    national_address: UploadFieldValue;
    has_website: "yes" | "no" | undefined;
    website: string;
    price_list: UploadFieldValue;
    organization_type: string;
    commercial_document: UploadFieldValue;
    owner_id: UploadFieldValue;
    iban_letter: UploadFieldValue;
    tax_register: UploadFieldValue;
    article_of_incorporation: UploadFieldValue;
  };
  [GET_PAID_STEP.AUTOMATION]: {
    iban_account: string;
    qpay_account: string;
    bank_transfer_fee_account: string;
    bank_acc_holder_name: string;
    bank_id: number;
    iban_number: string;
  };
  [GET_PAID_STEP.ACTIVATION]: {
    termsConditionsTahseel: boolean;
  };
}

export enum GET_PAID_STATUS {
  ACCEPTED = "accepted",
  CANCELLED = "cancelled",
  PENDING = "pending",
  PENDING_PAYMENT = "pending_payment",
  REJECTED = "rejected",
  UNSUBSCRIBED = "unsubscribed",
}

export enum GET_PAID_STEP {
  ORGANIZATION_INFO = "organizationInfo",
  AUTOMATION = "automation",
  ACTIVATION = "activation",
}

export interface GetPaidFormData {
  organization_industry: string;
  organization_size: string;
  national_address: File;
  has_website: "yes" | "no" | undefined;
  website: string;
  price_list: File;
  organization_type: string;
  commercial_document: File;
  owner_id: File;
  iban_letter: File;
  tax_register: File;
  iban_number: string;
  bank_acc_holder_name: string;
  bank_id: number;
  iban_account: string;
  qpay_account: string;
  bank_transfer_fee_account: string;
  termsConditionsTahseel: boolean;
  article_of_incorporation: File;
}
